import { Col, Collapse, Form } from 'antd';
import { string, object, bool } from 'prop-types';
import AddList from './AddList';

export default function ContactInfo(props) {
  const {
    name, id, formRef, readOnly, initialOrderData, initialInvoiceData,
  } = props;

  return (
    <Col span={24}>
      <Collapse defaultActiveKey={[id]} forceRender>
        <Collapse.Panel header={`业务往来信息（填写与${name}的业务往来信息）`} key={id} forceRender>
          <Col span={24}>
            <AddList
              formRef={formRef}
              title="订单"
              name={`orderAmount_${id}`}
              enterpriseName={name}
              dataFieldName={`orders_${id}`}
              isEdit={!readOnly}
              initialData={initialOrderData}
            />
          </Col>
          <Col span={24}>
            <AddList
              formRef={formRef}
              title="发票"
              name={`invoiceAmount_${id}`}
              enterpriseName={name}
              dataFieldName={`invoices_${id}`}
              isEdit={!readOnly}
              initialData={initialInvoiceData}
            />
          </Col>
          {/* 隐藏字段用于存储表格数据 */}
          <Form.Item hidden name={`orders_${id}`} initialValue={[]}>
            <div />
          </Form.Item>
          <Form.Item hidden name={`invoices_${id}`} initialValue={[]}>
            <div />
          </Form.Item>
        </Collapse.Panel>
      </Collapse>
    </Col>
  );
}

ContactInfo.propTypes = {
  name: string.isRequired,
  id: string.isRequired,
  formRef: object.isRequired,
  readOnly: bool,
  initialOrderData: object,
  initialInvoiceData: object,
};

ContactInfo.defaultProps = {
  readOnly: false,
  initialOrderData: undefined,
  initialInvoiceData: undefined,
};
